import axios from "axios";

export default function getHolidays() {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/business-holidays")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
